/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_InvalidInputs */

const en_workflow_time_invalid = /** @type {(inputs: Workflow_Time_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid date and time.`)
};

const ja_workflow_time_invalid = /** @type {(inputs: Workflow_Time_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効な日付と時刻を入力してください。`)
};

const fr_workflow_time_invalid = /** @type {(inputs: Workflow_Time_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir une date et une heure valides.`)
};

const de_workflow_time_invalid = /** @type {(inputs: Workflow_Time_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib ein gültiges Datum und eine gültige Uhrzeit ein.`)
};

/**
* | output |
* | --- |
* | "Please enter a valid date and time." |
*
* @param {Workflow_Time_InvalidInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_invalid = /** @type {((inputs?: Workflow_Time_InvalidInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_InvalidInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_invalid(inputs)
	if (locale === "ja") return ja_workflow_time_invalid(inputs)
	if (locale === "fr") return fr_workflow_time_invalid(inputs)
	return de_workflow_time_invalid(inputs)
});